import authenticateTranslations from './partials/authenticate'
import buttonTranslations from './partials/button'
import enumsTranslations from './partials/enums'
import attributeTranslations from './partials/attributes'
import globalTranslations from './partials/global'
import navigationTranslations from './partials/navigation'
import toastsTranslations from './partials/toasts'
import validationTranslations from './partials/validation'
import worksTranslations from './partials/works'

export default {
  ...authenticateTranslations,
  ...buttonTranslations,
  ...enumsTranslations,
  ...attributeTranslations,
  ...globalTranslations,
  ...navigationTranslations,
  ...toastsTranslations,
  ...validationTranslations,
  ...worksTranslations
}
